import { Select } from '@chakra-ui/react'

export default Select
